import { createAction } from '@reduxjs/toolkit';
import * as itemTypes from '../items/item-types';
import {
  getItem as getItemInternal,
  saveItem as saveItemInternal
} from '../items/item.actions';
import { GROUP_OPTIONS } from './report-builder';
import { METRICS } from './metrics';

export const receiveReport = createAction('receiveReport');
export const setReportIsBusy = createAction('setReportIsBusy');
export const modifyReport = createAction('modifyReport');
export const closeReport = createAction('closeReport');

export const reportModel = (id, name, params) => ({
  id,
  name,
  type: itemTypes.REPORT,
  metrics: [],
  groups: [],
  filters: [],
  excludedFilters: [],
  showTrend: true
});

export const getItem = getItemInternal(
  reportModel,
  receiveReport,
  setReportIsBusy,
  item => {
    //API is not peristing array is we send a 0 length array, so re-initialized the property to an empty array to keep other code cleaner
    if (!Array.isArray(item.metrics)) {
      item.metrics = [];
    } else {
      // quietly drop metrics no longer supported in the UI
      item.metrics = item.metrics.filter(m =>
        METRICS.some(metric => metric.property === m)
      );
    }
    if (!Array.isArray(item.groups)) {
      item.groups = [];
    } else {
      // quietly drop groups no longer supported in the UI
      item.groups = item.groups.filter(g =>
        GROUP_OPTIONS.some(option => option.field === g)
      );
    }
    if (!Array.isArray(item.filters)) {
      item.filters = [];
    }
    if (!Array.isArray(item.excludedFilters)) {
      item.excludedFilters = [];
    }
  }
);
export const saveItem = saveItemInternal(modifyReport);
